/**
 * Regex pattern for validating email addresses.
 *
 * Business rules:
 * - Requires valid characters before @ symbol: letters, numbers, and ._%+-
 * - Requires valid domain name after @ symbol
 * - Requires at least one dot followed by a TLD of 2+ letters
 * - Rejects invalid formats like "foo@foo" without a proper TLD
 *
 * `@example`
 * EMAIL_REGEX.test('user@example.com') // true
 * EMAIL_REGEX.test('foo@foo') // false
 *
 * `@see` isValidEmail
 */
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Validates if a string is a properly formatted email address.
 *
 * @param value - The email string to validate
 * @returns true if the email is valid, false otherwise
 *
 * `@example`
 * isValidEmail('user@example.com') // true
 * isValidEmail('foo@foo') // false
 */
export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value);
}
